document.addEventListener("click", (event) => {
	// Check if the clicked element has a data-layer-push attribute
	const element = event.target.closest("[data-layer-push]");

	// If no matching element found, exit early
	if (!element) return;

	window.dataLayer = window.dataLayer || [];
	let datalayerEvent = {
		event: element.dataset.event,
	};

	if (element.dataset.category || element.dataset.action || element.dataset.label) {
		const events = {
			events: {
				category: element.dataset.category,
				action: element.dataset.action,
				label: element.dataset.label,
			},
		};

		datalayerEvent = { ...datalayerEvent, ...events };
	}

	if (element.dataset.datalayerEvents) {
		datalayerEvent = { ...datalayerEvent, ...JSON.parse(element.dataset.datalayerEvents) };
	}

	window.dataLayer.push(datalayerEvent);
});

// Hero Slider datalayer tracking
document.addEventListener("click", (event) => {
	const element = event.target.closest("[data-layer-slider]");

	if (!element) return;

	window.dataLayer = window.dataLayer || [];

	const dataLayerConfig = JSON.parse(element.dataset.layerSlider);
	const { target } = event;

	if (!dataLayerConfig) {
		return;
	}

	if (target.nodeName === "A") {
		if (target.classList.contains("c-button")) {
			window.dataLayer.push({
				event: `${dataLayerConfig.event}_cta`,
				hero_titel: dataLayerConfig.hero_titel,
				CTA_naam:
					target.title || target.querySelector(".c-button__label").innerText,
				link_URL: target.href,
			});
		} else {
			window.dataLayer.push({
				event: `${dataLayerConfig.event}_link`,
				hero_titel: dataLayerConfig.hero_titel,
				link_naam: target.title || target.innerText,
				link_URL: target.href,
			});
		}
	} else if (
		target.nodeName === "SPAN" &&
		target.classList.contains("c-button__label")
	) {
		window.dataLayer.push({
			event: `${dataLayerConfig.event}_cta`,
			hero_titel: dataLayerConfig.hero_titel,
			CTA_naam: target.title || target.innerText,
			link_URL: target.closest("a").href,
		});
	}
});
